const OVERRIDES = {
  doi_or_url: 'DOI / URL',
  url: 'URL',
  id: 'ID',
  industrial_application: 'Case Study Application',//Decision talking to Agnes August 7th
};

const LOWERCASE_WORDS = new Set(['of', 'the', 'and', 'in', 'to', 'a', 'or']);

/**
 * Turns a snake_case schema key or enum value into human-readable words,
 * without changing its meaning (no renaming/repurposing).
 */
export function humanize(key) {
  if (key === undefined || key === null) return '';
  const raw = String(key);
  if (OVERRIDES[raw]) return OVERRIDES[raw];

  const words = raw.split('_').filter(Boolean);
  return words
    .map((w, i) =>
      i > 0 && LOWERCASE_WORDS.has(w) ? w : w.charAt(0).toUpperCase() + w.slice(1)
    )
    .join(' ');
}
